import {Translatable} from 'common/i18n';
import {MultiAttributionType} from 'common/types/reports/bookmark';

import {MultiAttribution, MultiAttributionWeights} from './types';

type AttributionSpec = {
  // Description displayed along options for attribution type
  description: Translatable;
  icon: string;
  label: Translatable;
  // Values specified here: https://www.notion.so/mxpnl/Attribution-Mechanics-4d71a5dfca2e465687aecaa3cbce4363
  weights?: MultiAttributionWeights;
};

export const CustomDefaultWeights = Object.freeze({first: 33, middle: 34, last: 33});

export const AttributionTypeToSpec: Record<MultiAttributionType, AttributionSpec> = {
  [MultiAttributionType.FirstTouch]: {
    description: ({t}) => t(`query-builder.attribution.model.description.first-touch`),
    icon: `attribution-first-touch`,
    label: ({t}) => t(`query-builder.attribution.model.first-touch`),
    weights: {
      first: 100,
      middle: 0,
      last: 0,
    },
  },
  [MultiAttributionType.LastTouch]: {
    description: ({t}) => t(`query-builder.attribution.model.description.last-touch`),
    icon: `attribution-last-touch`,
    label: ({t}) => t(`query-builder.attribution.model.last-touch`),
    weights: {
      first: 0,
      middle: 0,
      last: 100,
    },
  },
  [MultiAttributionType.Linear]: {
    description: ({t}) => t(`query-builder.attribution.model.description.linear`),
    icon: `attribution-linear`,
    label: ({t}) => t(`query-builder.attribution.model.linear`),
    weights: {
      first: 33,
      middle: 33,
      last: 33,
    },
  },
  [MultiAttributionType.Participation]: {
    description: ({t}) => t(`query-builder.attribution.model.description.participation`),
    icon: `attribution-participation`,
    label: ({t}) => t(`query-builder.attribution.model.participation`),
  },
  [MultiAttributionType.TimeDecay]: {
    description: ({t}) => t(`query-builder.attribution.model.description.time-decay`),
    icon: `attribution-time-decay`,
    label: ({t}) => t(`query-builder.attribution.model.time-decay`),
  },
  [MultiAttributionType.UShaped]: {
    description: ({t}) => t(`query-builder.attribution.model.description.u-shaped`),
    icon: `attribution-u-shaped`,
    label: ({t}) => t(`query-builder.attribution.model.u-shaped`),
    weights: {
      first: 40,
      middle: 20,
      last: 40,
    },
  },
  [MultiAttributionType.JShaped]: {
    description: ({t}) => t(`query-builder.attribution.model.description.j-shaped`),
    icon: `attribution-j-shaped`,
    label: ({t}) => t(`query-builder.attribution.model.j-shaped`),
    weights: {
      first: 20,
      middle: 20,
      last: 60,
    },
  },
  [MultiAttributionType.InverseJShaped]: {
    description: ({t}) => t(`query-builder.attribution.model.description.inverse-j_shaped`),
    icon: `attribution-inverse-j-shaped`,
    label: ({t}) => t(`query-builder.attribution.model.inverse-j_shaped`),
    weights: {
      first: 60,
      middle: 20,
      last: 20,
    },
  },
  [MultiAttributionType.Custom]: {
    description: ({t}) => t(`query-builder.attribution.model.description.custom`),
    icon: `attribution-custom`,
    label: ({t}) => t(`query-builder.attribution.model.custom`),
  },
};

export const DefaultMultiAttribution: MultiAttribution = Object.freeze({
  type: MultiAttributionType.LastTouch,
});
